import styled from "styled-components";

import { Fonts } from "assets/fonts";
import { viewPortBreakpoints } from "ui/styles/viewport";

import { ButtonPrimary, ButtonSecondary } from "../Button";

const Header = styled.header`
  margin-bottom: 16px;

  @media (min-width: ${viewPortBreakpoints.lg}) {
    margin-bottom: 32px;
  }
`;

const Title = styled.h1`
  text-align: center;
  ${Fonts.semiBold_22}
`;

const Content = styled.section`
  padding: 16px 0;
  ${Fonts.regular_16}
`;

const Text = styled.div`
  ${Fonts.regular_16}
`;

const Paragraph = styled.p`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Footer = styled.footer`
  display: flex;
  justify-content: space-evenly;
  gap: 12px;
  margin-top: 24px;
`;

const CancelButton = styled(ButtonSecondary)``;

const ConfirmButton = styled(ButtonPrimary)``;

const ConfirmDangerButton = styled(ConfirmButton)`
  background-color: ${(p) => p.theme.errorHighestContrast};
  border-color: ${(p) => p.theme.errorHighestContrast};

  &:enabled:hover {
    background-color: ${(p) => p.theme.errorHighContrast};
    border-color: ${(p) => p.theme.errorHighContrast};
  }
`;

export const StyledModal = {
  Header,
  Title,
  Content,
  Text,
  Paragraph,
  Footer,
  CancelButton,
  ConfirmButton,
  ConfirmDangerButton,
};
